// extracted by mini-css-extract-plugin
module.exports = {"online":"NetworkStatus_online__Ts2KZ","offline":"NetworkStatus_offline__1qDfk"};